import { render, staticRenderFns } from "./PickupLocations.vue?vue&type=template&id=83c106d6"
import script from "./PickupLocations.vue?vue&type=script&lang=js"
export * from "./PickupLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports